<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    :title="title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-12">
        <w-input :model="$schema.name" />
      </div>
    </div>

    <div class="row mt-2">
      <div class="form-group col-12">
        <w-input :model="$schema.path" />
      </div>
    </div>

    <div class="row mt-2">
      <div class="form-group col-12">
        <w-checkbox :model="$schema.active" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { ActionList } from '@/enums/action.enum';
import { EventTypeList } from '@/enums/eventType.enum';
import { formMixin } from '@/mixins/form';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/module.schema';

const emptyData = () => ({ name: null, path: null, active: null });

// @vuese
// Modal dodania modułu
// @group Module
export default {
  mixins: [manageMixin('module', {}, emptyData), formMixin],
  schema,
  data() {
    return { model: {} };
  },
  computed: {
    title() {
      return this.id ? 'Edycja modułu' : 'Dodawanie modułu';
    }
  }
};
</script>